import { render, staticRenderFns } from "./StaticLayout.vue?vue&type=template&id=882ad774&"
import script from "./StaticLayout.vue?vue&type=script&lang=js&"
export * from "./StaticLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports